export default __webpack_public_path__ + "static/media/search_icon.62915ef8.svg";